"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;
/*eslint-disable*/const messages = {
  Apply: "Aplicar",
  Clear: "Limpar",
  "Date picker open, choose a date": "Seletor de datas aberto, escolha uma data",
  "Date range picker open, select a date range": "Seletor de intervalo de datas aberto, selecione um intervalo",
  "End Date": "Data de término",
  "Please enter a valid date ({format})": ["Insira uma data válida (", ["format"], ")"],
  "Please select a date after {minDate}": ["Selecione uma data posterior a ", ["minDate"]],
  "Please select a date before {maxDate}": ["Selecione uma data anterior a ", ["maxDate"]],
  "Show next month": "Exibir próximo mês",
  "Show previous month": "Exibir mês anterior",
  "Start Date": "Data de início",
  "The selected date is disabled": "A data selecionada está desabilitada",
  "The selected date is unavailable. Please select another.": "A data selecionada não está disponível. Selecione outra opção.",
  Today: "Hoje",
  "Today, {dateStr}": ["Hoje, ", ["dateStr"]],
  "date picker": "seletor de datas",
  "start date selected": "data de início selecionada",
  to: "a",
  "{dateStr}, select end date": [["dateStr"], ", selecione a data de término"],
  "{dateStr}, select start date": [["dateStr"], ", selecione a data de início"],
  "{startDate} to {endDate}, choose apply to confirm, or cancel": [["startDate"], " a ", ["endDate"], ", escolha aplicar para confirmar ou cancele"]
};
exports.messages = messages;
//# sourceMappingURL=messages.js.map